/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleSquareFill: {
  name: 'circle-square-fill';
  data: string;
} = {
  name: 'circle-square-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm12 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-6Z" fill="currentColor"/></svg>`,
};
